<template>
  <div class="carousel">
    <button @click="prev" class="arrow" aria-label="Image précédente" title="Image précédente">&laquo;</button>
        <img :src="images[current]" :alt="alt" :title="title" class="carousel-img" />
    <button @click="next" class="arrow" aria-label="Image suivante" title="Image suivante">&raquo;</button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
const props = defineProps({
  images: Array,
  alt: String,
  title: String
});
const current = ref(0);
function prev() {
  if (current.value === 0) {
    current.value = props.images.length - 1;
  } else {
    current.value--;
  }
}
function next() {
  if (current.value === props.images.length - 1) {
    current.value = 0;
  } else {
    current.value++;
  }
}

</script>

<style scoped>
.carousel {
  display: flex;
  align-items: center;
  gap: 0.1rem;
}
.carousel-img {
  max-width: 250px;
  border-radius: 8px;
  box-shadow: 0 2px 8px #0002;
}
.arrow {
  background: #eee;
  border: none;
  font-size: 1.5rem;
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background 0.2s;
}

.arrow:hover {
  color: #2faa61;
}

.arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>